import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class PWADetectorService {
  public isPWA() {
      return window.matchMedia('(display-mode: standalone)').matches ||
          (window.navigator as any).standalone ||
          document.referrer.includes('android-app://');
  }
}
